import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';

const LANGS = [
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'en', label: 'EN' },
];

export default function LanguageSwitcher({ style, compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || 'zh';

  // 手机端：三语平铺太宽(约130px)会把头部撑出屏幕 → 收成单个下拉，只显示当前语言。
  if (compact) {
    const cur = LANGS.find(l => l.code === current) || LANGS[0];
    const items = LANGS.map(l => ({ key: l.code, label: l.label, onClick: () => i18n.changeLanguage(l.code) }));
    return (
      <Dropdown menu={{ items, selectedKeys: [current] }} trigger={['click']} placement="bottomRight">
        <button
          aria-label="切换语言"
          style={{
            display: 'flex', alignItems: 'center', gap: 3, flexShrink: 0,
            padding: '4px 9px', borderRadius: 14, border: 'none',
            background: '#F4F1EC', color: '#7A7268', fontSize: 12, cursor: 'pointer',
            ...style,
          }}
        >🌐 {cur.label}</button>
      </Dropdown>
    );
  }

  return (
    <div style={{ display: 'flex', gap: 2, background: '#F4F1EC', borderRadius: 14, padding: 2, ...style }}>
      {LANGS.map(l => (
        <button
          key={l.code}
          onClick={() => i18n.changeLanguage(l.code)}
          style={{
            padding: '3px 8px',
            borderRadius: 12,
            border: 'none',
            cursor: 'pointer',
            fontSize: 11,
            fontWeight: current === l.code ? 600 : 400,
            background: current === l.code ? '#fff' : 'transparent',
            color: current === l.code ? '#B8892A' : '#7A7268',
            boxShadow: current === l.code ? '0 1px 3px rgba(0,0,0,.1)' : 'none',
            transition: 'all .15s',
          }}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
